import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { MatDialogRef } from '@angular/material/dialog';
import { HandlerManager } from 'src/app/managers/handler/handler.manager';
import { LoadingManager } from 'src/app/managers/loading/loading.manager';
import { SessionManager } from 'src/app/managers/session/session.manager';
import { NotifierManager } from 'src/app/managers/notifier/notifier.manager';
import { Notifier } from 'src/app/enums/notifier/notifier.enum';
import { NotifierMessage } from 'src/app/enums/notifier/message/notifier.enum';
import { RoutingPages } from 'src/app/enums/routing/routing-pages.enum';
import { SessionCode } from 'src/app/enums/session/session-code.enum';
import { User } from 'src/app/beans/login/user/user.bean';
import { LoginForcedDialog } from 'src/app/dialogs/login-forced/login-forced.dialog';
import { DialogsReturnCode } from 'src/app/enums/dialogs/returnCode.enum';

/**
 * Pagina di ritorno dopo il login OIDC su authproxy (auth.codaq.it): l'utente e' gia'
 * autenticato in sessione li', qui si scambia quell'identita' per un token legacy valido
 * su apiwebapp (via authproxy -> sb_auth) e si prosegue come un login normale.
 */
@Component({
  selector: 'sso-callback',
  templateUrl: './sso.callback.page.html',
  styleUrls: ['./sso.callback.page.scss'],
})
export class SsoCallbackPage implements OnInit {
  constructor(
    private _handler: HandlerManager,
    private _loader: LoadingManager,
    private _session: SessionManager,
    private _notifier: NotifierManager,
    private _router: Router
  ) {}

  async ngOnInit() {
    await this.attemptLogin(false);
  }

  async attemptLogin(forced: boolean) {
    this._loader.start();
    const result = await this._handler.sso().legacyLogin('WEBAPP', forced);
    this._loader.stop();

    if (!result) {
      this._notifier.show(Notifier.ERROR, NotifierMessage.LOGIN_GENERIC);
      this._router.navigate([RoutingPages.LANDING_RAW]);
      return;
    }

    // Utente gia' loggato altrove: stessa dialog del login classico, "continua" ripete
    // la richiesta con forced=true invece di sovrascrivere in silenzio.
    if (result instanceof MatDialogRef) {
      const dialog = result as MatDialogRef<LoginForcedDialog>;
      dialog.afterClosed().subscribe((data) => {
        if (data?.code == DialogsReturnCode.LOGIN_FORCED_ACCEPT) {
          this.attemptLogin(true);
        } else {
          this._router.navigate([RoutingPages.LANDING_RAW]);
        }
      });
      return;
    }

    if (User.isKind(result)) {
      const user = result as User;
      if (this._session.user().set(user) === SessionCode.OK) {
        this._router.navigate([RoutingPages.MAIN]);
        return;
      }
    }

    // Altri result code negativi (es. operatore non autorizzato): ErrorManager ha gia'
    // mostrato la notifica giusta dentro SsoHandler.legacyLogin, qui resta solo il redirect.
    this._router.navigate([RoutingPages.LANDING_RAW]);
  }
}
